"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonQuotedColumnParser = void 0;
const ColumnFormatter_1 = require("./ColumnFormatter");
const Token_1 = require("../Token");
class NonQuotedColumnParser {
  constructor(parserOptions) {
    this.parserOptions = parserOptions;
    this.columnFormatter = new ColumnFormatter_1.ColumnFormatter(parserOptions);
  }
  parse(scanner) {
    if (!scanner.hasMoreCharacters) {
      return null;
    }
    const {
      parserOptions
    } = this;
    const characters = [];
    let nextToken = scanner.nextCharacterToken;
    for (; nextToken; nextToken = scanner.nextCharacterToken) {
      if (Token_1.Token.isTokenDelimiter(nextToken, parserOptions) || Token_1.Token.isTokenRowDelimiter(nextToken)) {
        break;
      }
      characters.push(nextToken.token);
      scanner.advancePastToken(nextToken);
    }
    return this.columnFormatter.format(characters.join(''));
  }
}
exports.NonQuotedColumnParser = NonQuotedColumnParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb2x1bW5Gb3JtYXR0ZXJfMSIsInJlcXVpcmUiLCJUb2tlbl8xIiwiTm9uUXVvdGVkQ29sdW1uUGFyc2VyIiwiY29uc3RydWN0b3IiLCJwYXJzZXJPcHRpb25zIiwiY29sdW1uRm9ybWF0dGVyIiwiQ29sdW1uRm9ybWF0dGVyIiwicGFyc2UiLCJzY2FubmVyIiwiaGFzTW9yZUNoYXJhY3RlcnMiLCJjaGFyYWN0ZXJzIiwibmV4dFRva2VuIiwibmV4dENoYXJhY3RlclRva2VuIiwiVG9rZW4iLCJpc1Rva2VuRGVsaW1pdGVyIiwiaXNUb2tlblJvd0RlbGltaXRlciIsInB1c2giLCJ0b2tlbiIsImFkdmFuY2VQYXN0VG9rZW4iLCJmb3JtYXQiLCJqb2luIiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYXJzZXIvY29sdW1uL05vblF1b3RlZENvbHVtblBhcnNlci50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQ0EsTUFBQUEsaUJBQUEsR0FBQUMsT0FBQTtBQUVBLE1BQUFDLE9BQUEsR0FBQUQsT0FBQTtBQUVBLE1BQWFFLHFCQUFxQjtFQUs5QkMsWUFBbUJDLGFBQTRCO0lBQzNDLElBQUksQ0FBQ0EsYUFBYSxHQUFHQSxhQUFhO0lBQ2xDLElBQUksQ0FBQ0MsZUFBZSxHQUFHLElBQUlOLGlCQUFBLENBQUFPLGVBQWUsQ0FBQ0YsYUFBYSxDQUFDO0VBQzdEO0VBRU9HLEtBQUtBLENBQUNDLE9BQWdCO0lBQ3pCLElBQUksQ0FBQ0EsT0FBTyxDQUFDQyxpQkFBaUIsRUFBRTtNQUM1QixPQUFPLElBQUk7O0lBRWYsTUFBTTtNQUFFTDtJQUFhLENBQUUsR0FBRyxJQUFJO0lBQzlCLE1BQU1NLFVBQVUsR0FBRyxFQUFFO0lBQ3JCLElBQUlDLFNBQVMsR0FBR0gsT0FBTyxDQUFDSSxrQkFBa0I7SUFDMUMsT0FBT0QsU0FBUyxFQUFFQSxTQUFTLEdBQUdILE9BQU8sQ0FBQ0ksa0JBQWtCLEVBQUU7TUFDdEQsSUFBSVgsT0FBQSxDQUFBWSxLQUFLLENBQUNDLGdCQUFnQixDQUFDSCxTQUFTLEVBQUVQLGFBQWEsQ0FBQyxJQUFJSCxPQUFBLENBQUFZLEtBQUssQ0FBQ0UsbUJBQW1CLENBQUNKLFNBQVMsQ0FBQyxFQUFFO1FBQzFGOztNQUVKRCxVQUFVLENBQUNNLElBQUksQ0FBQ0wsU0FBUyxDQUFDTSxLQUFLLENBQUM7TUFDaENULE9BQU8sQ0FBQ1UsZ0JBQWdCLENBQUNQLFNBQVMsQ0FBQzs7SUFFdkMsT0FBTyxJQUFJLENBQUNOLGVBQWUsQ0FBQ2MsTUFBTSxDQUFDVCxVQUFVLENBQUNVLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztFQUMzRDs7QUF6QkpDLE9BQUEsQ0FBQW5CLHFCQUFBLEdBQUFBLHFCQUFBIiwiaWdub3JlTGlzdCI6W119